import {
  TEMPLATE_CREATE_AGREEMENT_TEMPLATE_BEGIN,
  TEMPLATE_CREATE_AGREEMENT_TEMPLATE_SUCCESS,
  TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE,
  TEMPLATE_CREATE_AGREEMENT_TEMPLATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createAgreementTemplate(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: TEMPLATE_CREATE_AGREEMENT_TEMPLATE_BEGIN,
    });

    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates`,
        args.values,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: TEMPLATE_CREATE_AGREEMENT_TEMPLATE_SUCCESS,
              data: res,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE,
              data: { error: 'Failed' },
            });
            let errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateAgreementTemplateError() {
  return {
    type: TEMPLATE_CREATE_AGREEMENT_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_CREATE_AGREEMENT_TEMPLATE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createAgreementTemplatePending: true,
        createAgreementTemplateError: null,
      };

    case TEMPLATE_CREATE_AGREEMENT_TEMPLATE_SUCCESS:
      // The request is success
      return {
        ...state,
        createAgreementTemplatePending: false,
        createAgreementTemplateError: null,
        agreementTemplates: action.data,
      };

    case TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE:
      // The request is failed
      return {
        ...state,
        createAgreementTemplatePending: false,
        createAgreementTemplateError: action.data.error,
      };

    case TEMPLATE_CREATE_AGREEMENT_TEMPLATE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createAgreementTemplateError: null,
      };

    default:
      return state;
  }
}
